import { createContext, useContext } from "react";
import type { MediaErrorCause } from "../lib/deviceErrors";

/**
 * Carries the local participant's camera-acquisition failure down to whichever
 * tile component renders that participant (GH-1179). The camera affordance is
 * placed *inside the local video-tile placeholder* — but tiles are rendered
 * deep inside the layout components (GridLayout / SpeakerLayout / SidebarLayout / MeetingRoom)
 * from LiveKit track hooks, not from InCallView/RoomView props. A context keeps
 * the plumbing out of the layout components: the owning view provides the cause,
 * and only the tile matching the local participant reads it.
 */
const LocalCameraAffordanceContext = createContext<MediaErrorCause | null>(null);

export const LocalCameraAffordanceProvider = LocalCameraAffordanceContext.Provider;

export function useLocalCameraAffordance(): MediaErrorCause | null {
  return useContext(LocalCameraAffordanceContext);
}
